import React, { useCallback, useEffect, useState } from 'react'
import { DownloadIcon, DeleteIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Heading,
  Image,
  Progress,
  Text,
  IconButton,
} from '@chakra-ui/react'
import { PospImages } from 'Assets/Posp'
import FileUpload from 'Components/FileUpload'
import { useUploadNocDocumentMutation } from 'Services/API/posp.api'
import { useDropzone } from 'react-dropzone'
import { ToastService } from 'Services/toast.service'

const NOCUpload = ({ setIsNocUploaded, noc, setNoc, nocPreview, setNocPreview }: any) => {
  // const [noc, setNoc] = useState<any>(null)
  // const [nocPreview, setNocPreview] = useState<any>(null)

  const [fileSize, setFileSize] = useState<any>(0)
  const [loadProgress, setLoadProgress] = useState(20)

  const [uploadNocDocument] = useUploadNocDocumentMutation()

  const handleFileCancel = (key: string) => {
    switch (key) {
      case 'noc': {
        setNoc(null)
        setNocPreview('')
        setIsNocUploaded(false)
        break
      }
    }
  }

  const onNocBackDrop = useCallback((acceptedFiles: File[]) => {
    setNoc(acceptedFiles[0])
    setNocPreview(URL.createObjectURL(acceptedFiles[0]))
    const size = (Math.round(acceptedFiles[0].size) / (1024 * 1024)).toFixed(2)
    setFileSize(size)
    setInterval(() => {
      setLoadProgress((loadProgress) => loadProgress + loadProgress / 2)
    }, 200)
    setIsNocUploaded(true)
  }, [])

  const NocUpload = useDropzone({
    // disabled: !consentAccepted,
    onError: () => {
      ToastService.showErrorToast({ title: 'Error', message: 'Invalid file' })
    },
    onDrop: onNocBackDrop,
    multiple: false,
    accept: {
      'application/pdf': ['.pdf'],
    },
  })

  const handleDownloadNoc = () => {
    const fileUrl = 'https://foundation-dev.theblackswan.in/media/mg5oDhU-3oJ6JjNvg2WE7Q=='
    const a = document.createElement('a')
    const outputFilename = 'POSP_NOC.docx'
    a.href = fileUrl
    a.target = '_blank'
    a.setAttribute('download', outputFilename)
    a.click()
  }

  useEffect(() => {
    setLoadProgress(20)
  }, [noc])

  return (
    <Box>
      <Divider mt={5} />
      <Box mt={5}>
        <Heading as='h4' size='xs'>
          Re- register for Zopper Insurance Brokers Private Limited
        </Heading>

        <Text width='100%' color='#B5B5B5' textAlign='left' fontSize='xs' mt={4}>
          Upload NOC received from previous organization. Refer “POSP_NOC.docx” in download section
        </Text>

        <Center mt={5}>
          <Button
            onClick={handleDownloadNoc}
            leftIcon={<DownloadIcon />}
            borderRadius='20'
            variant='outline'
          >
            NOC Template
          </Button>
        </Center>

        {/* <FileUpload
          customStyleBoxWidth='100%'
          id={1}
          handleFileCancel={handleFileCancel}
          uploadDesc='Upload NOC'
          getRootProps={NocUpload.getRootProps}
          getInputProps={NocUpload.getInputProps}
          preview={noc}
          previewUrl={nocPreview}
          inputFieldImage={PospImages.BulkUploadFile}
        />
        {nocPreview ? (
          <Flex w='100%'>
            <Image src={PospImages.FileIcon} mr={2} />
            <Box w='100%'>
              <Text fontSize='xs' fontWeight='normal' color='#5F6265'>
                {noc.name}
              </Text>
              <Progress size='xs' hasStripe={true} isAnimated={true} value={loadProgress} />
              <Text fontSize='12px' color='#AAAAAA'>
                {fileSize} mb
              </Text>
            </Box>
            <IconButton
              onClick={() => {
                setNoc(null)
                setNocPreview('')
                setIsNocUploaded(false)
              }}
              ml={2}
              variant='outline'
              aria-label='delete'
              colorScheme='gray'
              icon={<DeleteIcon />}
            />
          </Flex>
        ) : null} */}
      </Box>
    </Box>
  )
}

export default NOCUpload
